/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { RichText } from "@simplicitycms/simplicity-richtext";
import { RichTextImage } from "cms/shared/images/rich-text-image";

const RichTextWithImageComponent = (props) => {

    let component = props?.component;
    let richtext = component?.richtext;
    let image = component?.image;
    let side = component?.side ?? "left";
    let displayWidth = component?.displayWidth;
    let displayHeight = component?.displayHeight;
    let settings = component?.settings;
    // object-fit: cover;

    const orientation = (displayWidth > displayHeight) ? "horizontal" : "vertical";
    return (
        <div className="simplicity-richtext-wrap">
            {image && (
                <div
                    className={`simplicity-richtext-wrap-image ${side} ${orientation}`}
                    // style={{
                    //     width: displayWidth,
                    //     height: displayHeight
                    // }}
                >
                    <RichTextImage
                        width={displayWidth}
                        height={displayHeight}
                        image={image}
                        settings={settings}
                        orientation={orientation}
                    />
                </div>
            )}
            <div className="rich-text-wrap read-only">
                <RichText richtext={richtext} />
            </div>
        </div>
    );
};

RichTextWithImageComponent.displayName = "RichTextWithImageComponent";
export { RichTextWithImageComponent };
